import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard";
import RegisterPage from "./pages/RegisterPage";
import StatsPage from "./pages/StatsPage";
import ProfilePage from "./pages/ProfilePage";
import GuildStatsPage from "./pages/GuildStatsPage";
import AdminPage from "./pages/AdminPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DiscordCallbackPage from "./pages/DiscordCallbackPage";
import GlobalStatsPage from "./pages/GlobalStatsPage";
import HuntersChancePage from "./pages/HuntersChancePage";
import HuntersChanceAdminPage from "./pages/HuntersChanceAdminPage";
import OreStoreAdminPage from "./pages/OreStoreAdminPage";
import BountyDetailPage from "./pages/BountyDetailPage";
import ExpeditionDetailPage from "./pages/ExpeditionDetailPage";
import OreStorePage from "./pages/OreStorePage";
import RankingsPage from "./pages/RankingsPage";
import Shoutbox from "./components/Shoutbox";
import AdminOreStoreHeartbeat from "./components/AdminOreStoreHeartbeat";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/guild-stats" element={<GuildStatsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/orestore" element={<OreStoreAdminPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/auth/discord/callback" element={<DiscordCallbackPage />} />
          <Route path="/global-stats" element={<GlobalStatsPage />} />
          <Route path="/hunters-chance" element={<HuntersChancePage />} />
          <Route path="/hunters-chance/admin" element={<HuntersChanceAdminPage />} />
          <Route path="/hunters-chance/bounty/:id" element={<BountyDetailPage />} />
          <Route path="/hunters-chance/expedition/:id" element={<ExpeditionDetailPage />} />
          <Route path="/orestore" element={<OreStorePage />} />
          <Route path="/rankings" element={<RankingsPage />} />
        </Routes>
        <Shoutbox />
        <AdminOreStoreHeartbeat />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
